import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IPartyGroup } from "rl-common/components/contacts/models/i-party-group";
import { DropdownOptions } from "rl-common/components/dropdown/dropdown.models";
import { IContactPartyParams } from "rl-common/components/mod-details-layout/mod-layout-sections-params.models";
import { IPanelSection } from "rl-common/components/mod-details-layout/mod-layout.models";
import { ICharacteristicMetaDataCollection } from "rl-common/models/i-characteristic-meta-data-collection";
import { ComponentChanges } from "rl-common/models/i-component-change";
import { OneConfigService } from "rl-common/services/one-config/one-config.service";
import { SessionService } from "rl-common/services/session.service";
import { DropdownSingleComponent } from "rl-common/components/dropdown/dropdown-single/dropdown-single.component";
import { FormTableControlDirective } from "rl-common/components/form-table/form-table-control.directive";
import { FormTableLabelDirective } from "rl-common/components/form-table/form-table-label.directive";
import { FormTableRowComponent } from "rl-common/components/form-table/form-table-row/form-table-row.component";


@Component({
	selector: "rl-build-contact-party-group-element",
	templateUrl: "./build-contact-party-group-element.component.html",
	styleUrls: ["./build-contact-party-group-element.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [FormTableRowComponent, FormTableLabelDirective, FormTableControlDirective, DropdownSingleComponent, ReactiveFormsModule, FormsModule]
})
export class BuildContactPartyGroupElementComponent implements OnInit, OnChanges {
	private readonly _oneConfig = inject(OneConfigService);
	private readonly _session = inject(SessionService);


	@Input()
	templateMetaData: ICharacteristicMetaDataCollection;

	@Input()
	section: IPanelSection<IContactPartyParams>;

	@Output()
	paramsChange = new EventEmitter<IContactPartyParams>();

	params: IContactPartyParams;

	partyGroups: DropdownOptions<IPartyGroup> = {
		items: [],
		rowKeyFn: (type: IPartyGroup) => type.groupID,
		rowLabelFn: (type: IPartyGroup) => type.groupLabel
	};

	defaultPartyGroup: IPartyGroup = {
		divisionID: null,
		groupID: null,
		groupLabel: "Select",
		groupDescription: null,
		expandIndicator: null,
		expandGroupIndicator: null,
		systemIndicator: null,
		visibilityIndicator: null,
		sequenceNumber: null,
		userID: null
	};

	selectedPartyGroup: IPartyGroup = this.defaultPartyGroup;

	ngOnInit() {
		const groupIds = this._oneConfig.getParties(this.templateMetaData.charTypeID, this.templateMetaData.templateID).map(x => x.partyGroupID);
		const noPartyGroup: IPartyGroup = {
			divisionID: this._session.divId,
			groupID: 0, // group id 0 is used for the "no party group" option
			groupLabel: "[No Party Group]",
			groupDescription: "[No Party Group]",
			sequenceNumber: 0,
			expandIndicator: 0,
			expandGroupIndicator: 1,
			systemIndicator: 0,
			visibilityIndicator: 2,
			userID: 0
		};
		const partyGroups = this._oneConfig.getPartyGroups().filter(grp => groupIds.includes(grp.groupID));
		partyGroups.push(noPartyGroup);
		this.partyGroups.items = partyGroups;

		this.updateSelected(this.section?.params?.groupId);
	}

	ngOnChanges(changes: ComponentChanges<this>): void {
		if (changes.section && changes.section.currentValue?.params?.groupId !== changes.section.previousValue?.params?.groupId) {
			this.updateSelected(this.section?.params?.groupId);
		}
	}

	private updateSelected(groupId: number) {
		if (groupId !== null && groupId !== undefined) {
			const found = this.partyGroups.items.find(x => x.groupID === groupId) ?? this.defaultPartyGroup;
			this.selectedPartyGroup = found;
		}
	}

	updateParams() {
		const fieldSectionParams: IContactPartyParams = {
			groupId: this.selectedPartyGroup?.groupID
		};

		this.params = fieldSectionParams;
		this.paramsChange.emit(fieldSectionParams);
	}

}
